import { Box, Paper, Step, StepContent, StepLabel, Stepper, Typography } from '@mui/material';
import React from 'react';

interface HowItWorksStep {
  title: string;
  text: string;
}

interface HowItWorksSectionProps {
  title?: string;
  steps?: HowItWorksStep[];
}

const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({ title = 'How It Works', steps }) => {
  if (!steps || steps.length === 0) return null;

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        {title}
      </Typography>
      <Box>
        <Stepper orientation="vertical" activeStep={-1}>
          {steps.map((step, idx) => (
            <Step key={`${step.title}-${idx}`} expanded>
              <StepLabel>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  {step.title}
                </Typography>
              </StepLabel>
              <StepContent>
                <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                  {step.text}
                </Typography>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Paper>
  );
};

export default React.memo(HowItWorksSection);
